import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  FormGroup,
  Label,
  Row,
  Col,
  Table,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
} from "availity-reactstrap-validation";
import Select from "react-select";
import TableScrollbar from "react-table-scrollbar";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import moment from "moment";
import Swal from "sweetalert2";

import "./NewRequestForQuotation.scss";
import {
  getUserLocations,
  getMiniTaxs,
  getMiniProductQualities,
} from "../../../store/Mini/actions";
import {
  getRFQList,
  InputChangeValue,
  rfqNoSelecteChangeValue,
  SelecteChangeValue,
  getRFQRequestdata,
  itemQtyChangeValue,
  itemUnitSelecteChangeValue,
  itemPriceChangeValue,
  itemDiscountPercentChangeValue,
  itemBasePriceChangeValue,
  itemTaxSelecteChangeValue,
  itemTaxTypeSelecteChangeValue,
  itemGrossValChangeValue,
  itemQualitiesChangeValue,
  quotationAdd,
  getQuotationData,
  QItemRemove,
  getMRItemImges,
  RFQMRItemImagesModel_close,
} from "../../../store/Quotation/actions";
import LoadingModel from "../../LoadingModel";
import ItemDetails from "../../ItemDetails";
import MRItemImages from "../../MRItemImages";

const taxTypeOptions = [
  { value: 1, label: "Inclusive" },
  { value: 2, label: "Exclusive" },
];
class NewQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item_details: {},
      selectedQualities: {},
      showAddMore: {},
      itemQualities: {},
      currentItemLoading: null,
    };

    this.loadRFQdata = this.loadRFQdata.bind(this);
    this.itemChangeHandeler = this.itemChangeHandeler.bind(this);
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.tog_static = this.tog_static.bind(this);
    this.caluclategross = this.caluclategross.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  caluclategross(e, item, type) {
    var qty;
    var price;
    var baseprice;
    var taxtype;
    var tax;
    var discountpercent;
    var discount;
    switch (type) {
      case 1:
        qty = e.target.value ? e.target.value : 0;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        this.props.itemQtyChangeValue({
          key: e.target.name,
          value: e.target.value ? e.target.value : 0,
          item,
        });
        break;
      case 2:
        qty = item.qty;
        price = item.price;
        discountpercent = parseFloat(
          e.target.value ? e.target.value : 0,
        ).toFixed(2);
        baseprice = parseFloat(item.baseprice ? item.baseprice : 0).toFixed(2);
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        price = parseFloat(
          baseprice - baseprice * (discountpercent / 100),
        ).toFixed(2);
        discount = parseFloat(baseprice - price).toFixed(2);

        this.props.itemDiscountPercentChangeValue({
          key: e.target.name,
          value: parseFloat(e.target.value ? e.target.value : 0),
          price,
          discount,
          item,
        });

        break;
      case 3:
        qty = item.qty;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = parseFloat(e.value ? e.value : 0);
        tax = item.tax?.tax;
        this.props.itemTaxTypeSelecteChangeValue({
          key: "taxtype_name",
          label: e.label,
          key2: "taxtype_id",
          value: parseFloat(e.value ? e.value : 0),
          item,
        });
        break;
      case 4:
        var taxData = this.props.Taxlist.filter((i) => {
          return i.id === e.value;
        });

        qty = item.qty;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = item.taxtype?.id;
        tax = taxData[0].tax;
        this.props.itemTaxSelecteChangeValue({
          id: taxData[0].id,
          name: taxData[0].name,
          tax: taxData[0].tax,
          item,
        });
        break;
      case 5:
        qty = item.qty;
        price = item.price;
        baseprice = parseFloat(e.target.value ? e.target.value : 0);
        discountpercent = item.discountpercent;
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        price = baseprice - baseprice * (discountpercent / 100);
        discount = parseFloat(baseprice - price).toFixed(2);

        this.props.itemBasePriceChangeValue({
          key: e.target.name,
          value: baseprice,
          price,
          discount,
          // discountpercent,
          item,
        });
        break;
      default:
        break;
    }

    var gross = price * parseFloat(qty).toFixed(3);
    var taxamt = 0;
    if (taxtype === 1) {
      var basicValue = gross / ((100 + tax) / 100);
      taxamt = (basicValue / 100) * tax;
      var net = parseFloat(taxamt + basicValue).toFixed(3);
    } else {
      taxamt = (gross * tax) / 100;
      net = parseFloat(parseFloat(gross) + parseFloat(taxamt)).toFixed(3);
    }

    this.props.itemGrossValChangeValue(
      parseFloat(taxamt).toFixed(3),
      net,
      item,
    );
  }
  loadQualities(item) {
    if (!item || !item.product) {
      console.warn(
        "[NewQuotation] loadQualities - item or product is undefined",
        item,
      );
      return;
    }

    const { miniProductQualitiesParams } = this.props;
    const params = {
      ...miniProductQualitiesParams,
      page: 1,
      page_size: 50,
      search: "",
      product: item.product.id,
    };

    this.props.getMiniProductQualities(params);
    this.setState({ currentItemLoading: item.id });
  }

  toggleAddMore = (item) => {
    const isOpening = !this.state.showAddMore[item.id];

    if (isOpening) {
      this.loadQualities(item);
    }

    this.setState((prev) => ({
      showAddMore: {
        ...prev.showAddMore,
        [item.id]: !prev.showAddMore[item.id],
      },
    }));
  };

  handleAddMoreSelect = (item, values) => {
    const safeValues = values || [];
    const newQualities = safeValues.map((v) => ({
      id: v.value,
      name: v.label,
    }));

    this.setState((prev) => ({
      selectedQualities: {
        ...prev.selectedQualities,
        [item.id]: newQualities.map((q) => q.id),
      },
    }));
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.miniProductQualitiesList !== this.props.miniProductQualitiesList
    ) {
      const { currentItemLoading, itemQualities } = this.state;

      if (currentItemLoading) {
        const rawResults = this.props.miniProductQualitiesList?.results || [];
        const allQualities =
          rawResults.length > 0 ? rawResults[0].qualities || [] : [];

        const mappedResults = allQualities.map((q) => ({
          ...q,
          label: q.name,
          value: q.id,
        }));

        this.setState({
          itemQualities: {
            ...itemQualities,
            [currentItemLoading]: mappedResults,
          },
          currentItemLoading: null,
        });
      }
    }
  }

  componentDidMount() {
    this.props.getRFQList();
    this.props.getUserLocations();
    this.props.getMiniTaxs();
    var id = 0;
    if (this.props.byVendor) {
      id = parseInt(this.props.openId);
      this.props.getRFQRequestdata(
        this.props.VendorData.requestforquotation,
        this.props.byVendor,
      );
    } else {
      id = parseInt(this.props.match.params.id);
    }
    if (id !== 0) {
      this.setState((prevState) => ({
        id: id,
        defaultColDef: {
          ...prevState.defaultColDef,
          editable: false,
        },
      }));
      this.props.getQuotationData(id);
    } else {
      this.setState({
        id: 0,
      });
    }
  }
  loadRFQdata() {
    this.props.getRFQRequestdata(
      this.props.QRfQNo.requestforquotation_id,
      false,
    );
  }
  itemChangeHandeler(e, item) {
    this.props.itemQtyChangeValue({
      key: e.target.name,
      value: e.target.value,
      item,
    });
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }

  RemoveQItem(item) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.QItemRemove(item);
      }
    });
  }
  handleValidSubmit() {

    const activeItems = this.props.qitems.filter(
    item => !item.dodelete && parseFloat(item.balance_qty) > 0
  );
    if (activeItems.length !== 0) {
      var quotationItems = [];
      activeItems.map((p) => {
        var qitem = {
          // id:this.state.id === 0 ? "" : p.id,
          product_id: p.product?.id,
          qty: parseFloat(p.qty ? p.qty : 0).toFixed(3),
          unit_id: p.unit?.id,
          tax_id: p.tax?.id,
          taxtype: p.taxtype?.id,
          taxamount: parseFloat(p.taxamt ? p.taxamt : 0).toFixed(2),
          rfqitem_id: p.rfqitem,
          price: parseFloat(p.price ? p.price : 0).toFixed(2),
          baseprice: parseFloat(p.baseprice ? p.baseprice : 0).toFixed(2),
          discount: parseFloat(p.discount ? p.discount : 0).toFixed(2),
          discountpercent: parseFloat(
            p.discountpercent ? p.discountpercent : 0,
          ).toFixed(2),
          gross: parseFloat(p.gross ? p.gross : 0).toFixed(2),
          make: p.make,
          description: p.description,
          dodelete: p.dodelete,
          quality_ids: p.selected_qualities || [],
        };
        if (this.state.id !== 0 && !this.props.byVendor) {
          qitem["id"] = p.id;
        }
        quotationItems.push(qitem);

        return 0;
      });
      var sum = 0;
      var totalsum = 0;
      activeItems.every((item, i) => {
        if (item.price) {
          if (item.taxtype != null && item.taxtype !== "") {
            if (item.tax?.id != null && item.tax?.id !== "") {
              sum = sum + parseFloat(item.gross);
              if (i + 1 === this.props.qitems.length) {
                totalsum = sum;
              }
              return true;
            } else {
              Swal.fire({
                icon: "error",
                title: "Select Tax",
              });
              return false;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Select Tax Type",
            });

            return false;
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Enter Price",
          });
          return false;
        }
      });

      var data = {
        token: this.props.token == null ? "" : this.props.token,
        deliverydate: this.props.QRowData.deliverydate,
        location_id: this.props.userLocation[0].id,
        requestforquotation_id:
          this.props.QRfQNo.requestforquotation_id == null
            ? this.props.byVendor
              ? this.props.VendorData.requestforquotation
              : this.props.QRowData.requestforquotation
            : this.props.QRfQNo.requestforquotation_id,
        description: this.props.QRowData.description,
        terms: this.props.QRowData.terms,
        total: parseFloat(totalsum ? totalsum : 0).toFixed(2),
        vendor_id: this.props.byVendor
          ? this.props.VendorData.vendor
          : this.props.QRowData.vendor_id,
        qitems: quotationItems,
      };
      if (data.vendor_id != null) {
        if (data.deliverydate != null) {
          if (data.terms != null) {
            if (data.description != null) {
              if (!isNaN(data.total) || data.total) {
                Swal.fire({
                  title: "Are you sure?",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Submit",
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.props.quotationAdd(
                      data,
                      this.state.id,
                      this.props.history,
                    );
                  }
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Check Item Details",
                });
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Enter Other Details",
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Enter Terms & Conditions",
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Select Delivery Date",
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Select Vendor",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Items are not found",
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <AvForm
              className="needs-validation"
              onValidSubmit={this.handleValidSubmit}
            >
              <Row>
                <Col md={12} className="p-1 W-100">
                  <Card className="p-0 ">
                    <CardHeader className="bg-transparent border-bottom ">
                      {!this.props.byVendor && (
                        <Link
                          to="/quotationdashboard"
                          className="action-icon text-primary mr-2"
                        >
                          {" "}
                          <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                        </Link>
                      )}
                      <h5 className="card-title-18 pt-2 d-inline-block">
                        New Quotation
                      </h5>
                    </CardHeader>
                    <CardBody className="p-2 ">
                      <Row className="pl-2 pr-2">
                        <Col md={4}>
                          <FormGroup className="mb-0 mr-2" row>
                            <Col md={4}>
                              <Label
                                htmlFor="rfqId"
                                className="col-form-label font-size-16"
                              >
                                Select RFQ No:
                              </Label>
                            </Col>
                            <Col md={8}>
                              {this.state.id === 0 && !this.props.byVendor && (
                                <Select
                                  id="rfqId"
                                  name="rfqId"
                                  classNamePrefix="select2-selection"
                                  options={this.props.rfqList.map(
                                    (item, index) => ({
                                      label: item.code,
                                      value: item.id,
                                    }),
                                  )}
                                  value={{
                                    label:
                                      this.props.QRfQNo.rfqLabel == null
                                        ? "Select RFQ No"
                                        : this.props.QRfQNo.rfqLabel,
                                    value:
                                      this.props.QRfQNo.requestforquotation_id,
                                  }}
                                  onChange={(e) => {
                                    this.props.rfqNoSelecteChangeValue({
                                      key: "rfqLabel",
                                      label: e.label,
                                      key2: "requestforquotation_id",
                                      value: e.value,
                                    });
                                  }}
                                />
                              )}
                              {(this.state.id !== 0 || this.props.byVendor) && (
                                <Input
                                  className="pr-0 "
                                  placeholder="RQF NO"
                                  type="text"
                                  disabled={true}
                                  name="rfqNo"
                                  id="rfqNo"
                                  value={
                                    this.props.byVendor
                                      ? this.props.RFQrowdata.code
                                      : this.props.QRowData
                                          .requestforquotation_code
                                  }
                                />
                              )}
                            </Col>
                          </FormGroup>
                        </Col>
                        {!this.props.byVendor && (
                          <Col md={2}>
                            <Button
                              type="button"
                              color="primary"
                              disabled={
                                this.state.id !== 0 || this.props.byVendor
                                  ? true
                                  : false
                              }
                              style={{ width: "100%" }}
                              className="waves-effect waves-light "
                              onClick={() => this.loadRFQdata()}
                            >
                              Load Data
                            </Button>
                          </Col>
                        )}
                        <Col md={3}>
                          <FormGroup className="mb-0 p-1" row>
                            <Col md={4}>
                              <Label
                                htmlFor="vendorId"
                                className="col-form-label font-size-16"
                              >
                                Select Vendor:
                              </Label>
                            </Col>
                            <Col md={8}>
                              {!this.props.byVendor && (
                                <Select
                                  id="vendorId"
                                  name="vendorId"
                                  classNamePrefix="select2-selection"
                                  isDisabled={
                                    this.props.qitems.length !== 0
                                      ? false
                                      : true
                                  }
                                  options={this.props.QVendorsList.map(
                                    (item, index) => ({
                                      label: item.name,
                                      value: item.id,
                                    }),
                                  )}
                                  value={{
                                    label:
                                      this.props.QRowData.vendLabel == null
                                        ? "Select Vendor"
                                        : this.props.QRowData.vendLabel,
                                    value: this.props.QRowData.vendor_id,
                                  }}
                                  onChange={(e) => {
                                    this.props.SelecteChangeValue({
                                      key: "vendLabel",
                                      label: e.label,
                                      key2: "vendor_id",
                                      value: e.value,
                                    });
                                  }}
                                />
                              )}
                              {this.props.byVendor && (
                                <Input
                                  className="pr-0 "
                                  placeholder="RQF NO"
                                  type="text"
                                  disabled={true}
                                  name="rfqNo"
                                  id="rfqNo"
                                  value={this.props.VendorData.vendor_name}
                                />
                              )}
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup className="mb-0 p-1" row>
                            <Col md={4}>
                              <Label
                                htmlFor="deliverydate"
                                className="col-form-label font-size-16"
                              >
                                Delivery Date:
                              </Label>
                            </Col>
                            <Col md={8}>
                              <Input
                                className="pr-0 "
                                placeholder="Quantity"
                                type="date"
                                min={moment(new Date()).format("YYYY-MM-DD")}
                                disabled={
                                  this.props.qitems.length !== 0 ? false : true
                                }
                                name="deliverydate"
                                id="deliverydate"
                                value={
                                  this.props.QRowData.deliverydate == null
                                    ? "Select date"
                                    : this.props.QRowData.deliverydate
                                }
                                onChange={this.ChangeHandeler}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="m-1">
                          <Card className="pt-1">
                            <CardBody className="p-0">
                              <div className="table-responsive m-1">
                                <TableScrollbar height="400px">
                                  <Table className="mb-0 p-1 ">
                                    <thead className="bg-light text-center">
                                      <tr>
                                        <th className="">S.No</th>
                                        <th className="">Item Images</th>
                                        <th>Item Name</th>
                                        <th>Available Qty</th>
                                        <th>Item Base Price</th>
                                        <th>Item Discount(%)</th>
                                        <th>Item Price</th>
                                        <th>Tax Type</th>
                                        <th>Tax (%)</th>
                                        <th>Gross Value</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {this.props.qitems.length !== 0 ? (
                                        this.props.qitems.map((item, key) => (
                                          <React.Fragment key={item.id || key}>
                                            {!item.dodelete && (
                                              <>
                                                <tr>
                                                  <td className="text-center">
                                                    {key + 1}
                                                  </td>

                                                  <td className="nowrap text-center">
                                                    <div className="product-detail text-center">
                                                      <img
                                                        src={
                                                          item?.product
                                                            ?.image == null
                                                            ? DefaultImg
                                                            : item?.product
                                                                ?.image
                                                        }
                                                        alt="product-img"
                                                        title="product-img"
                                                        className="product-img img-fluid mx-auto tab-img rounded"
                                                        style={{
                                                          height: "100px",
                                                          width: "150px",
                                                        }}
                                                      />
                                                    </div>
                                                  </td>

                                                  <td
                                                    style={{
                                                      minWidth: "220px",
                                                    }}
                                                  >
                                                    <h5 className="font-size-14">
                                                      <Link
                                                        to="#"
                                                        onClick={() =>
                                                          this.tog_static(item)
                                                        }
                                                        className="text-dark"
                                                      >
                                                        {item.product.name}
                                                      </Link>
                                                    </h5>

                                                    <p className="mb-0">
                                                      <b className="text-dark">
                                                        Make :
                                                      </b>{" "}
                                                      <span className="font-weight-medium">
                                                        {item.make}
                                                      </span>
                                                    </p>

                                                    <p className="mb-0">
                                                      <b className="text-dark">
                                                        Quantity :
                                                      </b>{" "}
                                                      <span className="font-weight-medium">
                                                        {item.originalqty}{" "}
                                                        {item.unit.name}
                                                      </span>
                                                    </p>

                                                    <p className="mb-0">
                                                      <b className="text-dark">
                                                        Available Qty :
                                                      </b>{" "}
                                                      <span className="font-weight-medium">
                                                        {item.balance_qty}{" "}
                                                        {item.unit.name}
                                                      </span>
                                                    </p>

                                                    <p className="mb-0">
                                                      <Link
                                                        to="#"
                                                        onClick={() =>
                                                          this.props.getMRItemImges(
                                                            item.id,
                                                          )
                                                        }
                                                        className="text-primary"
                                                      >
                                                        <u className="text-primary">
                                                          View Images
                                                        </u>
                                                      </Link>
                                                    </p>
                                                  </td>

                                                  {/* Available Qty */}
                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      minWidth: "220px",
                                                    }}
                                                  >
                                                    <AvField
                                                      placeholder="Quantity"
                                                      type="number"
                                                      name={"qty" + key}
                                                      value={item?.balance_qty}
                                                      disabled={
                                                        parseFloat(
                                                          item.balance_qty,
                                                        ) === 0
                                                      }
                                                      validate={{
                                                        required: {
                                                          value:
                                                            parseFloat(
                                                              item.balance_qty,
                                                            ) !== 0, // skip required if qty is 0
                                                          errorMessage:
                                                            "Please enter Qty",
                                                        },
                                                        max: {
                                                          value:
                                                            item?.balance_qty !==
                                                              undefined &&
                                                            item?.balance_qty !==
                                                              null
                                                              ? parseFloat(
                                                                  item.balance_qty,
                                                                )
                                                              : parseFloat(
                                                                  item.originalqty,
                                                                ),
                                                          errorMessage:
                                                            "Please enter max " +
                                                            (item?.balance_qty !==
                                                              undefined &&
                                                            item?.balance_qty !==
                                                              null
                                                              ? parseFloat(
                                                                  item.balance_qty,
                                                                )
                                                              : parseFloat(
                                                                  item.originalqty,
                                                                )),
                                                        },
                                                        min: {
                                                          value:
                                                            parseFloat(
                                                              item.balance_qty,
                                                            ) !== 0
                                                              ? 0.001
                                                              : 0, // allow 0 when disabled
                                                          errorMessage:
                                                            "Please enter min 0.1",
                                                        },
                                                      }}
                                                      onChange={(e) =>
                                                        this.caluclategross(
                                                          e,
                                                          item,
                                                          1,
                                                        )
                                                      }
                                                    />
                                                  </td>

                                                  {/* Base Price */}
                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      minWidth: "150px",
                                                    }}
                                                  >
                                                    <InputGroup>
                                                      <Input
                                                        placeholder="Item Base Price"
                                                        min={0}
                                                        type="number"
                                                        name={"baseprice" + key}
                                                        value={item.baseprice}
                                                        onChange={(e) =>
                                                          this.caluclategross(
                                                            e,
                                                            item,
                                                            5,
                                                          )
                                                        }
                                                      />

                                                      <InputGroupAddon addonType="append">
                                                        <InputGroupText>
                                                          &#8377;
                                                        </InputGroupText>
                                                      </InputGroupAddon>
                                                    </InputGroup>
                                                  </td>

                                                  {/* Discount */}
                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      minWidth: "100px",
                                                    }}
                                                  >
                                                    <AvGroup>
                                                      <InputGroup>
                                                        <AvInput
                                                          type="number"
                                                          name={
                                                            "discountpercent" +
                                                            key
                                                          }
                                                          value={
                                                            item.discountpercent
                                                          }
                                                          onChange={(e) =>
                                                            this.caluclategross(
                                                              e,
                                                              item,
                                                              2,
                                                            )
                                                          }
                                                        />
                                                        <InputGroupAddon>
                                                          %
                                                        </InputGroupAddon>
                                                      </InputGroup>
                                                    </AvGroup>
                                                  </td>

                                                  {/* Price */}
                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      minWidth: "150px",
                                                    }}
                                                  >
                                                    <InputGroup>
                                                      <Input
                                                        type="number"
                                                        name={"price" + key}
                                                        value={item.price}
                                                        disabled
                                                      />

                                                      <InputGroupAddon addonType="append">
                                                        <InputGroupText>
                                                          &#8377;
                                                        </InputGroupText>
                                                      </InputGroupAddon>
                                                    </InputGroup>

                                                    <p>
                                                      Item Discount: ₹{" "}
                                                      {item.discount}
                                                    </p>
                                                  </td>

                                                  {/* Tax Type */}
                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      minWidth: "120px",
                                                    }}
                                                  >
                                                    <Select
                                                      name={
                                                        "taxtype_select" + key
                                                      }
                                                      options={taxTypeOptions}
                                                      value={{
                                                        label:
                                                          item.taxtype?.name ??
                                                          (item.taxtype === 1
                                                            ? "Inclusive"
                                                            : item.taxtype === 2
                                                              ? "Exclusive"
                                                              : ""),
                                                        value: item.taxtype?.id,
                                                      }}
                                                      onChange={(e) =>
                                                        this.caluclategross(
                                                          e,
                                                          item,
                                                          3,
                                                        )
                                                      }
                                                    />
                                                  </td>

                                                  {/* Tax */}
                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      minWidth: "120px",
                                                    }}
                                                  >
                                                    <Select
                                                      name={
                                                        "units_select" + key
                                                      }
                                                      options={this.props.Taxlist.map(
                                                        (i) => ({
                                                          label: i.name,
                                                          value: i.id,
                                                        }),
                                                      )}
                                                      value={{
                                                        label: item.tax?.name,
                                                        value: item.tax?.id,
                                                      }}
                                                      onChange={(e) =>
                                                        this.caluclategross(
                                                          e,
                                                          item,
                                                          4,
                                                        )
                                                      }
                                                    />

                                                    <p>
                                                      Tax Amount: ₹{" "}
                                                      {item.taxamt}
                                                    </p>
                                                  </td>

                                                  {/* Gross */}
                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      minWidth: "180px",
                                                    }}
                                                  >
                                                    <AvField
                                                      type="number"
                                                      readOnly
                                                      name={"gross" + key}
                                                      value={item.gross}
                                                    />
                                                  </td>

                                                  {/* Remove */}
                                                  <td>
                                                    <Button
                                                      type="button"
                                                      color="danger"
                                                      onClick={() =>
                                                        this.RemoveQItem(item)
                                                      }
                                                    >
                                                      <i className="mdi mdi-close"></i>
                                                    </Button>
                                                  </td>
                                                </tr>

                                                {item.qualities &&
                                                  item.qualities.length > 0 && (
                                                    <tr>
                                                      <td colSpan={11}>
                                                        <div className="p-2">
                                                          <strong>
                                                            Qualities:
                                                          </strong>

                                                          <div className="mt-2">
                                                            {item.qualities.map(
                                                              (q) => (
                                                                <div
                                                                  key={q.id}
                                                                  className="form-check d-inline-block mr-3"
                                                                >
                                                                  <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id={`quality-${item.id}-${q.id}`}
                                                                    checked={
                                                                      item.selected_qualities?.includes(
                                                                        q.id,
                                                                      ) || false
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      const updated =
                                                                        e.target
                                                                          .checked
                                                                          ? [
                                                                              ...(item.selected_qualities ||
                                                                                []),
                                                                              q.id,
                                                                            ]
                                                                          : (
                                                                              item.selected_qualities ||
                                                                              []
                                                                            ).filter(
                                                                              (
                                                                                id,
                                                                              ) =>
                                                                                id !==
                                                                                q.id,
                                                                            );

                                                                      this.props.itemQualitiesChangeValue(
                                                                        {
                                                                          item,
                                                                          qualities:
                                                                            updated,
                                                                        },
                                                                      );
                                                                    }}
                                                                  />

                                                                  <label
                                                                    className="form-check-label ml-1"
                                                                    htmlFor={`quality-${item.id}-${q.id}`}
                                                                  >
                                                                    {q.name}
                                                                  </label>
                                                                </div>
                                                              ),
                                                            )}
                                                          </div>

                                                          <Button
                                                            type="button"
                                                            color="info"
                                                            size="sm"
                                                            className="ml-2"
                                                            onClick={() =>
                                                              this.toggleAddMore(
                                                                item,
                                                              )
                                                            }
                                                          >
                                                            Add More
                                                          </Button>

                                                          {this.state
                                                            .showAddMore[
                                                            item.id
                                                          ] &&
                                                            this.state
                                                              .itemQualities[
                                                              item.id
                                                            ] && (
                                                              <div
                                                                style={{
                                                                  width:
                                                                    "300px",
                                                                  marginTop:
                                                                    "10px",
                                                                }}
                                                              >
                                                                <Select
                                                                  isMulti
                                                                  classNamePrefix="react-select"
                                                                  options={this.state.itemQualities[
                                                                    item.id
                                                                  ].map(
                                                                    (q) => ({
                                                                      label:
                                                                        q.name,
                                                                      value:
                                                                        q.id,
                                                                    }),
                                                                  )}
                                                                  value={(
                                                                    item.selected_qualities ||
                                                                    []
                                                                  ).map(
                                                                    (id) => {
                                                                      const q =
                                                                        this.state.itemQualities[
                                                                          item
                                                                            .id
                                                                        ].find(
                                                                          (x) =>
                                                                            x.id ===
                                                                            id,
                                                                        );
                                                                      return q
                                                                        ? {
                                                                            label:
                                                                              q.name,
                                                                            value:
                                                                              q.id,
                                                                          }
                                                                        : null;
                                                                    },
                                                                  )}
                                                                  onChange={(
                                                                    values,
                                                                  ) => {
                                                                    const safeValues =
                                                                      values ||
                                                                      [];
                                                                    this.props.itemQualitiesChangeValue(
                                                                      {
                                                                        item,
                                                                        qualities:
                                                                          safeValues.map(
                                                                            (
                                                                              v,
                                                                            ) =>
                                                                              v.value,
                                                                          ),
                                                                      },
                                                                    );
                                                                  }}
                                                                />
                                                              </div>
                                                            )}
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                              </>
                                            )}
                                          </React.Fragment>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={11}
                                            className="text-center"
                                          >
                                            <span className="font-size-18 text-danger">
                                              Data not available
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </TableScrollbar>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1 ">
                              <i className="mdi mdi-alert-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Terms & Conditions
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <AvField
                                    name="terms"
                                    id="txtterms"
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter Terms & Conditions"
                                    rows="7"
                                    value={
                                      this.props.QRowData.terms == null
                                        ? ""
                                        : this.props.QRowData.terms
                                    }
                                    onChange={this.ChangeHandeler}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1">
                              <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Other Details
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <AvField
                                    name="description"
                                    id="description"
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter Details"
                                    value={
                                      this.props.QRowData.description == null
                                        ? ""
                                        : this.props.QRowData.description
                                    }
                                    rows="7"
                                    onChange={this.ChangeHandeler}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>

                      <CardFooter className="bg-transparent p-1">
                        <div className="float-right">
                          {this.props.byVendor && (
                            <Link to={"/vendorlogin/" + this.props.token}>
                              <Button
                                type="reset"
                                color="light"
                                className="waves-effect waves-light mr-2"
                              >
                                Cancel
                              </Button>
                            </Link>
                          )}
                          {!this.props.byVendor && (
                            <Link to="/QuotationDashboard">
                              <Button
                                type="button"
                                color="light"
                                className="waves-effect waves-light mr-2"
                              >
                                Cancel
                              </Button>
                            </Link>
                          )}
                          <Button
                            type="submit"
                            color="primary"
                            className="waves-effect waves-light"
                          >
                            Submit
                          </Button>
                        </div>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>

            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              // ItemLevel="QLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            {this.props.RFQMRItemImagesModel && (
              <MRItemImages
                modelOpen={this.props.RFQMRItemImagesModel}
                MRIImageData={this.props.RFQMRItemImages}
                modelClose={() => {
                  this.props.RFQMRItemImagesModel_close();
                }}
              />
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    userLocation,
    Taxlist,
    miniProductQualitiesList,
    miniProductQualitiesParams,
  } = state.Mini;
  const { VendorData } = state.VendorQuotation;
  const {
    rfqList,
    QRfQNo,
    QRowData,
    qitems,
    RFQrowdata,
    QVendorsList,
    loading,
    RFQMRItemImages,
    RFQMRItemImagesModel,
  } = state.Quotation;

  return {
    userLocation,
    Taxlist,
    VendorData,
    rfqList,
    QRfQNo,
    QRowData,
    QVendorsList,
    qitems,
    RFQrowdata,
    loading,
    RFQMRItemImages,
    RFQMRItemImagesModel,
    miniProductQualitiesList,
    miniProductQualitiesParams,
  };
};

export default connect(mapStatetoProps, {
  getUserLocations,
  getMiniTaxs,
  getMiniProductQualities,
  getRFQList,
  InputChangeValue,
  rfqNoSelecteChangeValue,
  SelecteChangeValue,
  getRFQRequestdata,
  itemQtyChangeValue,
  itemUnitSelecteChangeValue,
  itemPriceChangeValue,
  itemDiscountPercentChangeValue,
  itemBasePriceChangeValue,
  itemTaxSelecteChangeValue,
  itemTaxTypeSelecteChangeValue,
  itemGrossValChangeValue,
  itemQualitiesChangeValue,
  getQuotationData,
  quotationAdd,
  QItemRemove,
  getMRItemImges,
  RFQMRItemImagesModel_close,
})(NewQuotation);
